import { useSelector } from "react-redux";
import styles from "./index.module.scss";

const CITIES = [
  "Санкт-Петербург",
  "Москва",
  "Нижний Новгород",
  "Киров",
  "Ульяновск",
  "Петрозаводск",
];

export default function InstallWarning() {
  const { data } = useSelector((state) => state.popup);
  const { cityName } = useSelector((state) => state.location);

  const handleCityClick = (city) => {
    const subdomainMap = {
      "Санкт-Петербург": "spb",
      Москва: "msk",
      "Нижний Новгород": "nn",
      Киров: "kirov",
      Ульяновск: "ulyanovsk",
      Петрозаводск: "petrozavodsk",
    };
    const sub = subdomainMap[city];
    if (!sub) return;

    if (typeof window === "undefined") return;

    const { host, pathname, search } = window.location;
    const parts = host.split(".");
    let root = host;
    if (parts.length >= 2) {
      root = parts.slice(-2).join(".");
    }
    const params = new URLSearchParams(search || "");
    if (data?.productId) {
      params.set("calcProductId", String(data.productId));
    }
    if (data?.selectedElectricsId) {
      params.set("calcElectricsId", String(data.selectedElectricsId));
    }
    if (data?.selectedElectricsCode) {
      params.set("calcElectricsCode", String(data.selectedElectricsCode));
    }
    const newHost = `${sub}.${root}`;
    const newUrl = `${window.location.protocol}//${newHost}${pathname}?${params.toString()}`;
    window.location.href = newUrl;
  };

  return (
    <div className={styles.Wrapper}>
      <h2 className={styles.Title}>
        {cityName === "Россия"
          ? "Выберите город для установки фаркопа"
          : `Установка фаркопа с электрикой производится в следующих городах:`}
      </h2>
      <p className={styles.Text}>
        {cityName === "Россия" && "Наши сертифицированные центры в городах:"}
      </p>
      <div className={styles.Cities}>
        {CITIES.map((city) => (
          <button
            key={city}
            type="button"
            className={styles.CityButton}
            onClick={() => handleCityClick(city)}
          >
            {city}
          </button>
        ))}
      </div>
    </div>
  );
}
